var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 20,
    height: 20,
    fill: "url(#pattern0_998_7731)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_998_7731",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_998_7731",
    transform: "scale(0.015625)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_998_7731",
    width: 64,
    height: 64,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAAAXNSR0IArs4c6QAAAzxJREFUeF7lnEuOEzEQhn8nB+CxggsAa5AYJA4wcwC4QNTpSzA74BB5KAcgHIDXchBwBGA/iBWELWoZeUhHPZ3utF2u8gNWo4zc0/k+l8ttt2sUAEwmk9vj8fgZgIfmM4D3VVWdrlarz9vPWf8oy/KO1vppg+8MwOlisfiitvAfAFxrUW6UUsfz+fxTzvRlWR5prV8DuNLi+AHggZpOp2sAj3ogs5ZwAL7GXauiKL4ppW4c6OVfWuvj5XL5MadIKIrinlLqbUdkNzG+mwg4B3BzAC4rCZbwBvncCHgB4LFF72YxHCzCvom6rpOgSXTtJNHlJGkJjvAbAPeVoXQIGdM8yeHgyLDRWp+YvHYhIHcJVHjDvROQqwQf+D0BuUnwhe8UkIsEDvheAalL4II/KCBVCZzwgwIIEnbTi8WDlXMTbngrAalIkIC3FhBbghS8k4BYEiThnQWEliANTxLQkPAGwHWLTEZKjCHgyQLMhWVZ3tVamw0Hdgmu8D5bd5fWAha9eamJhISQ8F4RUJvglBAankUA13CIAc8mwFdCLHhWAVQJAH5b7N7WI459S84rCXYlTcK+nPkz0fYj2QUQIsFm8mHv+fqmIgKYJYjBs+eAdlc6TpFdkSAKLy7AMxLE4YMIIEoIAh9MgOM8b74XaQFlk03bbcSSYH0jAvxuzq/f3lDAbK8RFeABH0yCmAAG+CASRAQwwotLYBfwXz8KO/b8xVRnFkNSO0s2iZAtAijw9Qk0xydG1imSRYAPfN1LsSR4C+CAjynBSwAnfCwJZAES8DEkkARIwoeW4CwgBDxRAun0mpOAkPChJFgLiAEfQoKVgJjw0hIGBaQALynhoICU4FsS3g0cg6+bDybGXgGu8CF2b4i7TAcldApIGZ5bwp6AHOA5JfgclmZdltqs3bvaOHbY3nCgHpdPAp4jEigFE0nB+0pQ26JCUxEW7RU1Nfzb17nuR1ZVdTRUN9i8R7DXVT5CHCW8tKkbNN8nybDvE+WQGK3qBrOCd8wJg3WDWYR9XyRYDIe1yQG3AJgk2C6e/qmUOvlHiqdfAbjaEvW3eNr8civheVd5uU9CSuXajn8PcDYajZ7MZrOvfwCBe8l1dRyWrwAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close-icon.ee3bb76f1c389d4826de5fc3344cba54.svg";
export { ForwardRef as ReactComponent };